import React, {Component} from 'react';
import {Toast} from 'react-weui'
import axios from 'axios'
import {Page} from '../../components/index'
import {isLZWKAPP, judgeAPPVersion} from '../../utils'
import {toChannel} from '../../utils/connectApp'
import NewIntroItem from './NewIntroItem'
import "../../styles/subject/SubjectPage.css"
import JX from '../../images/jx_icon.png'


class BigImg extends Component {

    renderPrice() {
        const {content} = this.props;
        if (content.need_money){
            if (content.has_limitmoney){
                if (Number(content.limit_money) === 0){
                    return <p><span>限时免费</span></p>
                }else {
                    return <p>￥<span>{content.limit_money.split('.')[0]}</span>.{content.limit_money.split('.')[1]}</p>
                }
            }else {
                return <p>￥<span>{content.lecture_money.split('.')[0]}</span>.{content.lecture_money.split('.')[1]}</p>
            }
        }else {
            return null
        }
    }

    handleEnter() {
        let {url} = this.props.content;
        if (isLZWKAPP()){
            toChannel(this.props.content.id, 44813585)
        }else {
            window.location.href = `${url}&st=from_jx`;
        }
    }

    render() {
        const {content} = this.props;
        return (
            <div className="best__bigimg" onClick={() => this.handleEnter()}>
                <div className="bigimg__icon">
                    <img src={JX} alt=""/>
                </div>
                <div className="bigimg__img">
                    <img src={content.cover_url} alt=""/>
                </div>
                <div className="bigimg__title">
                    {content.name}
                </div>
                <div className="bigimg__message">
                    已更新{content.lecture_count}期  {content.popular}人气
                </div>
                <div className="bigimg__price">
                    {this.renderPrice()}
                </div>
                <div className="bigimg__enter">
                    马上学习
                </div>
            </div>
        )
    }
}


class BestSubjectPage extends Component {

    constructor() {
        super()
        this.state = {
            bestSubjectList: [],
            initialized: false,
        }
    }

    componentDidMount() {
        document.title = '精选专题';
        axios.get('/api/index/recommend', {
            params: {
                type: 'quality_zone'
            }
        }).then(res => {
            this.setState({
                bestSubjectList: res.data.data.recommends,
                initialized: true,
            })

        })
    }

    renderContent() {
        const {bestSubjectList} = this.state
        return (
            <div className="jx__introitem-container">
                {bestSubjectList.map((item) => <NewIntroItem content={item} key={item.id} type="channel" kurisu="1"/>)}
            </div>
        )
    }

    render() {
        const {initialized} = this.state

        return (
            <Page>
                <div className="subject-page" style={{paddingTop: '14px'}}>
                    <Toast icon="loading" show={!initialized}></Toast>

                    {initialized &&
                        this.renderContent()
                    }
                </div>
            </Page>
        )

    }
}

export default BestSubjectPage


// WEBPACK FOOTER //
// ./src/pages/BestSubjectPage/BestSubjectPage.js